import { render, staticRenderFns } from "./formPartage.vue?vue&type=template&id=57715dac&"
import script from "./formPartage.vue?vue&type=script&lang=js&"
export * from "./formPartage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports